// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__16ixt","title":"Images45_title__1D2JK","images":"Images45_images__2uJrg"};